/**
* Process Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Process Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'process-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth > 768 ) {
        let sliderWidth = 0;
        $( '.process-slider_slide' ).each( function() {
          sliderWidth = sliderWidth + $( this ).outerWidth();
        } );
        $( '.slider-width' ).innerWidth( sliderWidth );
        $( '.slider-width' ).css( {display: 'flex'} );
        const sections = gsap.utils.toArray( '.process-slider_slide' );

        gsap.to( sections, {
          xPercent: -100 * ( sections.length - 3 ),
          ease: 'none',
          scrollTrigger: {
            trigger: '.process-slider',
            start: 'bottom bottom',
            pin: true,
            scrub: 1,
            // snap: 1 / ( sections.length - 1 ),
            end: () => '+=' + ( document.querySelector( '.process-slider' ).offsetWidth ),
          },
        } );
        const progBar = gsap.utils.toArray( '.progress-bar-inner' );
        gsap.from( progBar, {
          width: 0,
          ease: 'none',
          stagger: {
            each: 0.5,
            onStart: function( ) {
              const currentItem = this.targets()[0];
              const thisParent = currentItem.parentElement.parentElement;
              const year = thisParent.querySelector( '.slider-year' );
              gsap.to( currentItem.nextElementSibling, {borderColor: '#D55411'} );
              gsap.to( year, {color: '#D55411'} );
            },
            onReverseComplete: function() {
              const currentItem = this.targets()[0];
              const thisParent = currentItem.parentElement.parentElement;
              const year = thisParent.querySelector( '.slider-year' );
              gsap.to( currentItem.nextElementSibling, {borderColor: 'white'} );
              gsap.to( year, {color: '#566E9A'} );
            },
          },
          scrollTrigger: {
            trigger: '.process-slider',
            start: 'bottom bottom',
            pin: true,
            scrub: 1,
            // snap: 1 / ( sections.length - 1 ),
            end: () => '+=' + ( document.querySelector( '.process-slider' ).offsetWidth ),
          },
        } );
      } else {
        const sections = gsap.utils.toArray( '.process-slider_slide' );
        const progBar = gsap.utils.toArray( '.progress-bar-inner' );

        gsap.from( progBar, {
          height: 0,
          ease: 'none',
          stagger: {
            each: 0.5,
            onStart: function( ) {
              const currentItem = this.targets()[0];
              const thisParent = currentItem.parentElement.parentElement;
              const year = thisParent.querySelector( '.slider-year' );
              gsap.to( currentItem.nextElementSibling, {borderColor: '#D55411'} );
              gsap.to( year, {color: '#D55411'} );
            },
            onReverseComplete: function() {
              const currentItem = this.targets()[0];
              const thisParent = currentItem.parentElement.parentElement;
              const year = thisParent.querySelector( '.slider-year' );
              gsap.to( currentItem.nextElementSibling, {borderColor: 'white'} );
              gsap.to( year, {color: '#566E9A'} );
            },
          },
          scrollTrigger: {
            trigger: '.process-slider',
            start: 'top top',
            end: 'bottom bottom',
            pin: false,
            scrub: 2,
          },
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'process-slider', COMPONENT );
} )( app );
